module.exports = __webpack_public_path__ + "static/media/login_logo.3825b437.svg";